const EmptySearchIcon = (props) => (
  <svg
    width={437}
    height={276}
    viewBox="0 0 437 276"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.68332 15.7684C2.01332 16.3484 -0.496679 19.7884 0.0833205 23.4684L27.8533 199.928C28.4333 203.598 31.8733 206.108 35.5533 205.528L164.063 185.298C167.733 184.718 170.243 181.278 169.663 177.598L146.463 30.2084L103.783 0.318359L5.68332 15.7684Z"
      fill="#F5F5F5"
    />
    <path
      d="M113.763 35.3584L146.473 30.2084L103.793 0.318359L108.733 31.6884C109.103 34.0984 111.353 35.7384 113.763 35.3584Z"
      fill="#D6D6D6"
    />
    <path
      d="M103.793 0.318359L108.733 31.6884C109.113 34.0884 111.363 35.7284 113.763 35.3484L146.473 30.1984"
      stroke="#262626"
      strokeWidth={0.274}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.6426 119.968C75.9326 115.468 75.7126 111.798 75.9626 108.948C76.2126 106.098 77.1526 103.368 78.7726 100.778C79.7026 99.2284 80.8126 97.8384 82.1026 96.6184C83.3926 95.3984 84.5626 94.1384 85.6126 92.8484C86.6526 91.5484 87.4926 90.1484 88.1126 88.6484C88.7326 87.1484 88.8726 85.2884 88.5226 83.0784C87.9326 79.3484 86.4926 76.8984 84.2026 75.7384C81.9126 74.5784 79.3526 74.2184 76.5326 74.6584C72.4926 75.2984 69.8926 76.8584 68.7226 79.3484C67.5526 81.8384 67.0726 85.0184 67.2926 88.8884L52.5526 91.2084C51.9626 87.4784 52.0426 83.9884 52.7826 80.7484C53.5226 77.5084 54.8426 74.6484 56.7626 72.1584C58.6726 69.6684 61.1226 67.6084 64.1026 65.9684C67.0826 64.3284 70.4826 63.2084 74.2926 62.6084C82.5226 61.3084 89.2826 61.9684 94.5726 64.5684C99.8626 67.1684 103.103 72.2484 104.293 79.7884C104.673 82.2284 104.763 84.3984 104.553 86.3084C104.343 88.2184 103.863 89.9884 103.103 91.6284C102.343 93.2684 101.343 94.8484 100.103 96.3784C98.8626 97.8984 97.4326 99.4884 95.8126 101.148C94.3426 102.708 93.1726 104.118 92.3226 105.388C91.4726 106.658 90.8726 107.938 90.5326 109.238C90.1926 110.538 90.0526 111.868 90.1026 113.228C90.1626 114.588 90.3226 116.108 90.5826 117.778L76.6426 119.968ZM79.6526 142.098L77.2926 127.128L92.7226 124.698L95.0826 139.668L79.6526 142.098Z"
      fill="#D6D6D6"
    />
    <path
      d="M152.134 128.818C169.144 145.538 188.934 168.098 207.314 197.258C220.104 217.538 229.584 236.838 236.664 253.818C220.354 261.158 204.054 268.498 187.744 275.828L145.824 133.168L152.134 128.818Z"
      fill="#FEC02D"
    />
    <path
      d="M121.233 117.278L152.593 127.078C161.183 140.708 166.153 152.778 169.063 161.168C182.633 200.268 178.283 236.048 177.053 246.158C177.053 246.158 177.033 246.328 173.083 275.818H29.6928C29.2228 265.128 29.3128 250.348 31.8328 233.018C34.8228 212.458 37.6028 193.378 50.0428 172.418C55.1028 163.898 72.6928 136.618 106.433 122.348C112.443 119.798 117.653 118.228 121.233 117.278Z"
      fill="#FEC02D"
    />
    <path
      d="M47.4729 176.978C64.9329 182.578 87.1529 188.078 113.283 190.748C137.613 193.238 159.073 192.648 176.453 191.018C176.953 195.118 177.453 199.218 177.953 203.318C159.383 204.828 137.303 205.288 112.593 203.128C84.9129 200.708 60.9429 195.618 41.4629 190.148C43.4629 185.758 45.4629 181.368 47.4729 176.978Z"
      fill="#FF7129"
    />
    <path
      opacity={0.5}
      d="M182.033 166.008L189.133 167.598L163.263 275.828H148.623L182.033 166.008Z"
      fill="#E8A600"
    />
    <path
      d="M124.013 255.098L130.093 253.198L144.033 260.408L147.553 251.878L129.853 245.078L122.633 248.458L124.013 255.098Z"
      fill="#E8A600"
    />
    <path
      opacity={0.5}
      d="M29.4629 259.618C43.6729 263.168 60.6729 266.348 79.9829 267.898C96.9129 269.248 112.223 269.068 125.453 268.178C125.453 262.748 125.453 257.308 125.453 251.878C93.8929 248.348 62.3429 244.828 30.7829 241.298L29.4629 259.618Z"
      fill="#E8A600"
    />
    <path
      d="M133.902 139.818C125.032 138.298 119.082 129.878 120.602 121.008L126.522 86.4583L158.632 91.9583L152.712 126.508C151.192 135.378 142.772 141.338 133.902 139.818Z"
      fill="#F7A99C"
    />
    <path
      d="M154.363 116.838L135.343 102.438C135.233 104.288 134.943 112.968 141.363 120.128C145.463 124.698 150.323 126.428 152.583 127.078L154.363 116.838Z"
      fill="#FF7769"
    />
    <path
      d="M127.623 75.6282C127.613 75.0882 126.373 74.0582 126.003 73.7182C125.373 73.1382 124.663 72.6382 123.903 72.2382C122.423 71.4582 120.723 71.0382 119.053 71.1282C115.723 71.2982 112.413 73.4882 111.313 76.6882C110.673 78.5482 110.763 80.5982 111.273 82.4982C112.043 85.3582 113.743 87.9382 116.013 89.8382C117.893 91.4082 120.153 92.5082 122.533 93.0782C123.013 93.1882 127.963 93.9382 127.953 93.7482C127.843 87.6982 127.733 81.6582 127.623 75.6282Z"
      fill="#F7A99C"
    />
    <path
      d="M123.163 75.1884C123.093 77.8284 122.973 91.8184 133.533 103.568C135.483 105.728 148.413 120.118 163.143 116.788C182.073 112.508 185.223 83.2084 185.373 81.6184C185.883 76.2384 187.383 60.4084 175.913 49.8084C166.553 41.1584 154.673 41.6484 152.983 41.7484C151.203 41.8484 139.833 42.6884 131.293 52.1984C123.553 60.8084 123.283 70.8584 123.163 75.1884Z"
      fill="#F7A99C"
    />
    <path
      d="M175.373 79.8782C175.263 82.1882 176.713 84.1382 178.623 84.2282C180.533 84.3182 182.173 82.5182 182.283 80.2082C182.393 77.8982 180.943 75.9482 179.033 75.8582C177.123 75.7682 175.483 77.5582 175.373 79.8782Z"
      fill="#262626"
    />
    <path
      d="M168.623 82.1782L171.003 86.9482C171.443 87.8282 171.033 88.8882 170.123 89.2482L166.953 90.4882"
      stroke="#262626"
      strokeWidth={1.7049}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M145.842 88.3084C145.712 90.8984 147.712 93.1084 150.312 93.2284C152.902 93.3584 155.112 91.3584 155.232 88.7584C155.362 86.1684 153.362 83.9584 150.762 83.8384C148.172 83.7184 145.962 85.7184 145.842 88.3084Z"
      fill="#FF7769"
    />
    <path
      d="M123.434 86.8484C123.534 86.3384 124.184 82.9084 121.854 79.9384C120.034 77.6084 117.534 77.0384 116.844 76.9084"
      stroke="#262626"
      strokeWidth={1.7049}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M122.003 80.6583C121.853 80.6083 120.043 80.0283 118.503 81.1983C117.233 82.1683 117.082 83.6083 117.062 83.8483"
      stroke="#262626"
      strokeWidth={1.7049}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M181.943 87.0983C182.843 87.1383 183.653 87.4483 184.353 87.9183C183.823 90.3883 183.063 93.3583 181.953 96.4683C181.803 96.4783 181.643 96.4983 181.493 96.4883C178.903 96.3583 176.903 94.1583 177.023 91.5683C177.143 88.9683 179.353 86.9683 181.943 87.0983Z"
      fill="#FF7769"
    />
    <path
      d="M156.922 74.9084L160.842 79.3484L155.232 81.3185"
      stroke="#262626"
      strokeWidth={1.7049}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M155.232 99.9583L169.322 101.568C169.282 101.278 168.662 97.1183 165.322 95.6083C162.042 94.1083 157.432 95.7583 155.232 99.9583Z"
      fill="white"
    />
    <path
      d="M123.313 71.9483C124.093 72.2483 125.923 73.0783 127.373 75.0383C128.713 76.8383 129.033 78.6583 129.133 79.4883C143.743 78.0983 152.183 73.9983 157.263 70.2983C157.263 70.2983 157.633 70.0284 168.343 61.8884C170.073 63.7484 172.773 66.2484 176.593 68.3884C180.063 70.3284 183.273 71.3183 185.623 71.8483C193.303 70.0583 198.653 64.3283 198.833 58.3383C199.023 52.0283 193.413 47.2583 189.433 45.2683C182.943 42.0283 179.953 45.8083 170.423 43.3183C162.743 41.3083 163.033 38.4183 155.833 36.6783C153.653 36.1483 144.623 33.9583 135.543 38.7383C127.883 42.7683 121.813 50.9083 121.213 60.2883C120.893 65.4183 122.283 69.5583 123.313 71.9483Z"
      fill="#262626"
    />
    <path
      d="M121.233 117.278C108.343 120.218 84.2434 127.638 61.7934 147.718C61.7934 147.718 39.1634 167.958 23.7334 205.498C22.3634 208.828 20.8334 212.338 19.1434 219.718C17.8334 225.438 17.2434 230.718 17.0534 235.318C16.9134 238.758 19.0334 241.898 22.2734 243.068C25.1234 244.098 28.3934 245.248 32.0234 246.468C38.7534 248.708 53.6734 254.818 70.5734 257.168C105.823 262.058 125.383 263.278 125.383 263.278L127.943 202.438L81.3534 196.538L121.233 117.278Z"
      fill="#FEC02D"
    />
    <path
      d="M158.883 148.568C164.733 169.038 168.363 186.168 170.653 198.658"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity={0.5}
      d="M97.9427 144.898L71.8027 203.778H87.6227L97.9427 144.898Z"
      fill="#E8A600"
    />
    <path
      d="M185.737 167.054L171.613 163.052L140.799 271.808L154.922 275.81L185.737 167.054Z"
      fill="#4A63A8"
    />
    <path
      d="M126.933 216.778C126.933 216.778 153.423 214.138 156.243 215.008C159.063 215.878 168.733 221.348 170.103 222.908C171.473 224.468 171.953 225.928 171.763 227.398C171.563 228.858 169.613 230.518 169.613 230.518C171.143 232.898 171.193 234.528 170.873 235.638C170.293 237.608 167.983 239.668 167.953 239.688C168.123 240.298 168.313 241.178 168.363 242.238C168.413 243.248 168.513 245.288 167.503 247.148C166.013 249.908 162.943 250.698 162.263 250.848C162.263 250.848 163.453 253.058 161.893 254.908C160.333 256.758 155.643 259.108 150.083 258.328C144.523 257.548 130.083 250.428 130.083 250.428L125.443 251.878L126.933 216.778Z"
      fill="#F7A99C"
    />
    <path
      opacity={0.5}
      d="M199.294 166.008C234.889 166.008 263.744 137.153 263.744 101.558C263.744 65.9637 234.889 37.1084 199.294 37.1084C163.699 37.1084 134.844 65.9637 134.844 101.558C134.844 137.153 163.699 166.008 199.294 166.008Z"
      fill="#CDEBF5"
    />
    <path
      d="M199.293 28.7283C159.073 28.7283 126.463 61.3383 126.463 101.558C126.463 141.778 159.073 174.388 199.293 174.388C239.513 174.388 272.123 141.778 272.123 101.558C272.123 61.3383 239.513 28.7283 199.293 28.7283ZM199.293 162.498C165.633 162.498 138.353 135.218 138.353 101.558C138.353 67.8983 165.633 40.6183 199.293 40.6183C232.943 40.6183 260.233 67.8983 260.233 101.558C260.233 135.218 232.943 162.498 199.293 162.498Z"
      fill="#4A63A8"
    />
    <path
      d="M169.614 230.528C169.614 230.528 159.854 228.708 154.924 226.418C149.994 224.128 148.164 222.868 148.164 222.868"
      stroke="#262626"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M167.954 239.698C167.954 239.698 156.644 238.568 152.064 235.928C147.474 233.288 145.834 231.568 145.834 231.568"
      stroke="#262626"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.224 250.168C159.384 249.978 155.744 248.898 153.204 247.858C148.974 246.118 143.684 242.818 143.684 242.818"
      stroke="#262626"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M126.933 216.778L125.453 251.878L130.093 250.428L128.603 216.608L126.933 216.778Z"
      fill="#FF7769"
    />
    <path
      d="M96.1129 148.568C96.1129 148.568 71.8129 201.998 72.4929 203.368C73.1829 204.748 127.943 202.448 127.943 202.448L125.383 263.288C125.383 263.288 82.6229 260.588 65.7029 256.388C48.7829 252.188 29.4629 245.608 29.4629 245.608"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M202.613 58.4083C202.233 59.2483 202.173 60.2283 202.523 61.1583C203.223 63.0283 205.313 63.9784 207.183 63.2784C210.583 61.9984 214.263 61.4683 217.833 61.7183C221.823 62.0083 224.873 63.2084 226.343 63.8984C228.083 64.7184 231.693 66.4183 234.393 70.1283C238.143 75.2983 237.833 81.3384 237.523 83.6984C237.263 85.6784 238.663 87.4984 240.643 87.7584C242.623 88.0183 244.443 86.6184 244.703 84.6384C245.223 80.6384 245.343 72.8784 240.253 65.8684C236.463 60.6484 231.533 58.3383 229.423 57.3483C227.073 56.2483 223.253 54.8584 218.363 54.5084C213.763 54.1784 209.013 54.8684 204.643 56.5084C203.703 56.8584 202.993 57.5583 202.613 58.4083Z"
      fill="white"
    />
    <path
      d="M75.8523 143.138C67.0123 150.998 55.6623 162.728 45.3023 178.988C34.6623 195.678 28.7723 211.338 25.4023 222.858"
      stroke="white"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M247.063 275.828H138.833C134.613 275.828 131.193 272.408 131.193 268.188V263.298H247.063V275.828Z"
      fill="#2A83C6"
    />
    <path
      d="M327.803 275.828H209.733C205.093 275.828 201.793 271.868 202.363 266.978L211.283 189.978C211.853 185.088 216.073 181.128 220.703 181.128H338.783C343.423 181.128 346.723 185.088 346.153 189.978L337.233 266.978C336.663 271.858 332.443 275.828 327.803 275.828Z"
      fill="#2A83C6"
    />
    <path
      d="M339.203 275.828H221.133C216.493 275.828 213.193 271.868 213.763 266.978L222.683 189.978C223.253 185.088 227.473 181.128 232.103 181.128H350.183C354.823 181.128 358.123 185.088 357.553 189.978L348.633 266.978C348.063 271.858 343.843 275.828 339.203 275.828Z"
      fill="#4C62A7"
    />
    <path
      d="M357.554 194.408L348.634 267.428C348.634 267.428 349.034 275.828 335.274 275.828C321.514 275.828 258.004 275.828 258.004 275.828C266.324 275.778 295.454 274.578 322.204 252.668C348.904 230.808 355.854 202.558 357.554 194.408Z"
      fill="#334A92"
    />
    <path
      d="M355.094 203.778C352.424 212.438 345.924 229.378 330.354 245.208C314.994 260.818 298.424 267.608 289.844 270.458"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M285.683 236.178H281.553L284.183 219.448H288.313L285.683 236.178Z"
      fill="#FEC02D"
    />
    <path
      d="M291.103 236.178H286.973L288.783 224.638H292.913L291.103 236.178Z"
      fill="#FEC02D"
    />
    <path
      d="M170.333 39.0183C164.373 42.3783 149.333 51.9083 139.463 71.1183C129.623 90.2783 130.613 107.998 131.343 114.808"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.613 241.889L175.293 225.519"
      stroke="#262626"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M406.522 225.548H251.822C248.272 225.548 245.402 222.678 245.402 219.128V105.868C245.402 102.318 248.272 99.4482 251.822 99.4482H406.522C410.072 99.4482 412.942 102.318 412.942 105.868V219.128C412.942 222.668 410.062 225.548 406.522 225.548Z"
      fill="#F5F5F5"
    />
    <path
      opacity={0.5}
      d="M412.942 114.038V105.868C412.942 102.318 410.072 99.4482 406.522 99.4482H251.822C248.272 99.4482 245.402 102.318 245.402 105.868V114.038H412.942Z"
      fill="#D6D6D6"
    />
    <path
      d="M254.113 107.508C254.113 108.608 253.223 109.498 252.123 109.498C251.023 109.498 250.133 108.608 250.133 107.508C250.133 106.408 251.023 105.518 252.123 105.518C253.223 105.518 254.113 106.408 254.113 107.508Z"
      fill="#F5F5F5"
    />
    <path
      d="M260.392 107.508C260.392 108.608 259.502 109.498 258.402 109.498C257.302 109.498 256.412 108.608 256.412 107.508C256.412 106.408 257.302 105.518 258.402 105.518C259.502 105.518 260.392 106.408 260.392 107.508Z"
      fill="#F5F5F5"
    />
    <path
      d="M266.812 107.508C266.812 108.608 265.922 109.498 264.822 109.498C263.722 109.498 262.832 108.608 262.832 107.508C262.832 106.408 263.722 105.518 264.822 105.518C265.922 105.518 266.812 106.408 266.812 107.508Z"
      fill="#F5F5F5"
    />
    <path
      opacity={0.5}
      d="M347.282 143.998V135.818C347.282 133.138 345.112 130.958 342.422 130.958H294.962C292.282 130.958 290.102 133.128 290.102 135.818V143.998V198.468C290.102 201.148 292.272 203.328 294.962 203.328H370.852C373.532 203.328 375.712 201.158 375.712 198.468V148.858C375.712 146.178 373.542 143.998 370.852 143.998H347.282Z"
      fill="#D6D6D6"
    />
    <path
      d="M342.472 155.418L332.912 164.978L323.352 155.418L317.582 161.188L327.142 170.748L317.582 180.308L323.352 186.078L332.912 176.518L342.472 186.078L348.242 180.308L338.682 170.748L348.242 161.188L342.472 155.418Z"
      fill="#D6D6D6"
    />
    <path
      d="M251.822 99.4482H406.522C410.072 99.4482 412.942 102.318 412.942 105.868V219.128"
      stroke="#262626"
      strokeWidth={0.274}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M398.363 128.618C397.623 122.768 397.483 117.988 397.923 114.308C398.363 110.628 399.693 107.128 401.903 103.828C403.163 101.858 404.663 100.108 406.383 98.5785C408.103 97.0485 409.673 95.4685 411.083 93.8285C412.483 92.1885 413.623 90.4085 414.493 88.4885C415.363 86.5685 415.613 84.1685 415.253 81.2885C414.643 76.4285 412.873 73.1985 409.953 71.5985C407.033 69.9985 403.733 69.4285 400.063 69.8885C394.803 70.5485 391.363 72.4685 389.753 75.6485C388.133 78.8285 387.393 82.9285 387.513 87.9485L368.313 90.3585C367.703 85.4985 367.943 80.9785 369.033 76.8085C370.123 72.6385 371.953 68.9785 374.533 65.8385C377.113 62.6985 380.363 60.1185 384.303 58.1085C388.233 56.0985 392.683 54.7885 397.643 54.1685C408.363 52.8185 417.093 53.9485 423.843 57.5285C430.593 61.1185 434.583 67.8185 435.823 77.6485C436.223 80.8285 436.243 83.6385 435.903 86.1085C435.553 88.5685 434.863 90.8485 433.813 92.9485C432.763 95.0485 431.403 97.0585 429.733 98.9785C428.063 100.908 426.143 102.908 423.983 104.988C422.013 106.948 420.443 108.738 419.283 110.338C418.123 111.948 417.293 113.588 416.803 115.258C416.303 116.938 416.073 118.658 416.093 120.408C416.113 122.168 416.263 124.148 416.533 126.328L398.363 128.618ZM401.373 157.418L398.923 137.918L419.013 135.398L421.463 154.898L401.373 157.418Z"
      fill="#8B3985"
    />
  </svg>
);
export default EmptySearchIcon;
